module.exports = __webpack_public_path__ + "assets/img/cpac.dce16569.png";